const handleClick = (event) => {
  // Find datasets in parents
  let trackingElement = event.target;
  while (trackingElement.parentNode) {
    if (trackingElement.dataset.position) {
      break;
    }

    trackingElement = trackingElement.parentNode;
  }

  if (window.dataLayer && trackingElement.dataset.position) {
    window.dataLayer.push({
      event: 'eec.promotionClick',
      ecommerce: { promoView: { promotions: [
        {
          'id': 'Partner Teaser',
          'name': 'Partnership Opportunities',
          'creative': trackingElement.dataset.creative,
          'position': trackingElement.dataset.position
        }
      ]}}
    });
  }

  trackingElement.removeEventListener('click', handleClick);
};

const handleIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'eec.promotionView',
        ecommerce: { promoView: { promotions: [
          {
            'id': 'Partner Teaser',
            'name': 'Partnership Opportunities',
            'creative': entry.target.dataset.creative,
            'position': entry.target.dataset.position
          }
        ]}}
      });
    }

    observer.unobserve(entry.target);
  });
};

if (window['IntersectionObserver']) {
  const observer = new IntersectionObserver(handleIntersection);

  // Partnership Opportunities
  const elements = document.querySelectorAll('.promotion[data-position]');
  elements.forEach((element) => {
    observer.observe(element);
    element.addEventListener('click', handleClick);
  });
}

